export default "__VITE_ASSET__B8rf6W3v__"